import { IApplicationState } from 'shared/types/redux';

export const selectUserId = (state: IApplicationState) => {
  return state.user.userId;
};
